import React, { useState } from 'react';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

export default function AI_Render(props) {

  const { setNodeData, nodeData } = props;
  const [conditions, ] = useState(["person", "bicycle", "backpack", "scooter", "wheelchair"]);
  const [selected_condition, setSelectedCondition] = useState(nodeData && nodeData.type==="ai"? nodeData.selectedCondition: conditions[0])

  setNodeData({
    type: "ai",
    selectedCondition: selected_condition
  })

  const handleChange = (event) => {
    setSelectedCondition(event.target.value)
    setNodeData({
      type: "ai",
      selectedCondition: event.target.value
    })
  }

    return(<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <TextField
      select
      id="outlined-required"
      label="IF"
      defaultValue={selected_condition}
      value={selected_condition}
      name="robot_actions"
      style={{width: "100%"}}
      onChange={handleChange}
    >
    {conditions.map((option) => (
        <MenuItem key={option} value={option}>
          {option}
        </MenuItem>
      ))}
    </TextField>
    </Grid>)
}